// extracted by mini-css-extract-plugin
export default {"wrapper":"AdminOrganizations_wrapper__98ldU"};